import React, { useEffect } from "react";
import { withMonogramContext } from "./MonogramContext";
import MonogramSwatches from "./MonogramSwatches";
import MonogramSettingHeader from "./MonogramSettingHeader";
import { getParamFromUrl } from "./util";

function MonogramFontStyles({
  chosenFont,
  chosenVariant,
  setChosenFont,
  setLoading,
  setChosenThreadColor,
  drawerFonts,
  chosenThreadColor,
  getThreadColorSwatch,
  initialPageLoad,
  chosenDecorativeColor,
  chosenOutlineColor,
  chosenDropShadowColor,
}) {
  const handleClick = async (font) => {
    setLoading(true);

    // delay set for loading to show
    await new Promise((resolve) => setTimeout(resolve, 500));

    const threadColor = font.thread_colors.find(
      (threadColor) => chosenThreadColor?.thread_color_name === threadColor
    );

    setChosenFont(font);
    setChosenThreadColor(getThreadColorSwatch(threadColor ? threadColor : font.thread_colors[0]));
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    if (!initialPageLoad.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("font", encodeURIComponent(chosenFont.font_name));
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [chosenFont]);

  useEffect(() => {
    if (!initialPageLoad.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("thread", chosenThreadColor.thread_color_name);
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [chosenThreadColor]);

  useEffect(() => {
    if (!initialPageLoad.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("decorative", chosenDecorativeColor.thread_color_name);
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [chosenDecorativeColor]);

  useEffect(() => {
    if (!initialPageLoad.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("outline", chosenOutlineColor.thread_color_name);
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [chosenOutlineColor]);

  useEffect(() => {
    if (!initialPageLoad.current) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("dropshadow", chosenDropShadowColor.thread_color_name);
    if (!chosenDropShadowColor?.thread_color_name) {
      urlParams.delete("dropshadow");
    }
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [chosenDropShadowColor]);

  return (
    <>
      <MonogramSettingHeader
        subtitlePrefix="Font Style"
        subtitle={chosenFont.font_name}
        withPadding
      />
      <MonogramSwatches
        swatches={drawerFonts
          .map((font) => ({
            imageSrc: font.font_swatch,
            selected: chosenFont.font_name === font.font_name,
            alt: font.font_name,
            value: font,
          }))
          .filter(({ imageSrc, alt }) => imageSrc && alt)}
        selectSwatch={handleClick}
        containImages
      />
    </>
  );
}

export default withMonogramContext(MonogramFontStyles);
